import * as React           from 'react'
import { FormattedMessage } from 'react-intl'
import styled, { css } from 'styled-components'

import Button, { ButtonProps }    from '@material-ui/core/Button'
import createStyles               from '@material-ui/core/styles/createStyles'
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles'
import AddIcon                    from '@material-ui/icons/Add'
import CancelIcon                 from '@material-ui/icons/Cancel'
import DeleteIcon                 from '@material-ui/icons/Delete'
import EditIcon                   from '@material-ui/icons/Edit'
import DownloadIcon               from '@material-ui/icons/FileDownload'
import RemoveIcon                 from '@material-ui/icons/Remove'
import UploadIcon                 from '@material-ui/icons/FileUpload'
import HistoryIcon                from '@material-ui/icons/History'
import ManageSearch               from '@material-ui/icons/Update'
import AssignmentTurnedIn         from '@material-ui/icons/AssignmentTurnedIn'

const buttonActionsPrefix = 'buttonActions.'
const buttonActionIds = {
  add:      buttonActionsPrefix + 'add',
  cancel:   buttonActionsPrefix + 'cancel',
  delete:   buttonActionsPrefix + 'delete',
  download: buttonActionsPrefix + 'download',
  edit:     buttonActionsPrefix + 'edit',
  update:   buttonActionsPrefix + 'update',
  remove:   buttonActionsPrefix + 'remove',
  submit:   buttonActionsPrefix + 'submit',
  save:     buttonActionsPrefix + 'save',
  up:       buttonActionsPrefix + 'up',
  history:   buttonActionsPrefix + 'history',
  active:   buttonActionsPrefix + 'active',
  finish: buttonActionsPrefix + 'finish', 
}

type ActionButtonType =
  | 'add'
  | 'cancel'
  | 'delete'
  | 'download'
  | 'edit'
  | 'update'
  | 'remove'
  | 'submit'
  | 'save'
  | 'up'
  | 'history'
  | 'active'
  | 'finish'

interface ActionButtonProps extends ButtonProps {
  actionType: ActionButtonType
  iconOnly?: boolean
  noIcon?: boolean
  theme?: any
  secondary?: boolean
}

const iconMap = {
  add:      AddIcon,
  cancel:   CancelIcon,
  delete:   DeleteIcon,
  download: DownloadIcon,
  edit:     EditIcon,
  remove:   RemoveIcon,
  save:     DownloadIcon,
  up:       UploadIcon,
  history:  HistoryIcon,
  active:   ManageSearch,
  finish:   AssignmentTurnedIn
}

const styles = createStyles({
  buttonIcon: {
    marginRight: 8,
  }
})



const ButtonStyled: any = styled(Button)`
  border: solid 1px ${({theme}) => theme.actionButtonBorderColor};
  color: ${({theme}) => theme.actionButtonFontColor};
  background-color: ${({theme}) => theme.actionButtonBackgroundColor};
  box-shadow: none;
  text-transform: capitalize;

  ${({theme, secondary, color}: ActionButtonProps) => (secondary || color === 'secondary') && css`
    background-color: ${theme.actionButtonBackgroundSecondaryColor};
    color: ${theme.actionButtonFontHoverSecondaryColor};
    text-transform: capitalize;
  `}

  ${({theme, color, variant}: ActionButtonProps) => (color === 'secondary' && variant === 'raised') && css`
    background-color: ${theme.ButtonBackgroundColor};
    border: solid 1px ${theme.ButtonBorderColor};
    color: ${theme.ButtonFontColor};
    text-transform: capitalize;
  `}

  &:hover {
    text-transform: capitalize;
    background-color: ${({theme, secondary, color}) => (secondary || color === 'secondary') 
    ? theme.actionButtonBackgroundHoverSecondaryColor
    : theme.actionButtonBackgroundHoverColor};
    color:  ${({theme, secondary, color}) => (secondary || color === 'secondary') 
    ? theme.actionButtonFontHoverSecondaryColor
    : theme.actionButtonFontHoverColor};
  }
`


const ActionButton = withStyles(styles)(
  (props: WithStyles<typeof styles> & ActionButtonProps) => {
    const { classes, actionType, noIcon, children, ...rest } = props

    const text = <FormattedMessage id={buttonActionIds[ actionType ]} />
    const Icon = iconMap[ actionType ]

    return (
      <ButtonStyled {...rest}>
        {!noIcon && Icon && <Icon className={classes.buttonIcon} />}
        {text}
        {children}        
      </ButtonStyled>
    )
  }
)

export default ActionButton



// WEBPACK FOOTER //
// ./src/components/atoms/ActionButton.tsx